export const ENTE_WEBSITE_LINK = 'https://ente.io';

export const ML_BLOG_LINK = 'https://ente.io/blog/desktop-ml-beta';

export const FACE_SEARCH_PRIVACY_POLICY_LINK =
    'https://ente.io/privacy#8-biometric-information-privacy-policy';
